import { ORIENTAL_D_GRAY, WHITE } from '../../constants';

export const stepperStyles = {
  root: {
    width: '100%',
  },
  zero_Padding: {
    padding: '0',
    margin: '0px 10px 12px',
    '@media (max-width:650px)': {
      width: '100%',
      margin: '0',
    },
  },
  stepperWrapperEng: {
    position: 'relative',
    height: '65px',
    '@media (max-width:650px)': {
      height: '90px',
    },
    '@media (max-width:600px)': {
      marginRight: '30px',
    },
  },
  stepperWrapperEsp: {
    position: 'relative',
    height: '65px',
    '@media (max-width:650px)': {
      height: '90px',
    },
    '@media (max-width:600px)': {
      marginRight: '50px',
    },
  },
  label: {
    marginTop: '7px',
    display: 'block',
    font: 'normal normal normal 12px Arial',
    fontWeight: '400',
    letterSpacing: '0.1px',
    color: ORIENTAL_D_GRAY,
    opacity: 1,
  },
  labelCompleted: {
    marginTop: '7px',
    display: 'block',
    font: 'normal normal normal 12px Arial',
    fontWeight: '700',
    letterSpacing: '0.1px',
    color: '#661C69',
    opacity: 1,
  },
  businessLabel: {
    marginTop: '7px',
    display: 'block',
    font: 'normal normal normal 12px Arial',
    fontWeight: '400',
    letterSpacing: '0.1px',
    color: ORIENTAL_D_GRAY,
    opacity: 1,
    width: 'min-content',
    '@media (max-width:600px)': {
      font: 'normal normal 700 12px/14px Arial',
      fontWeight: '400',
      letterSpacing: '0.1px',
      color: ORIENTAL_D_GRAY,
      opacity: 1,
      width: 'min-content',
    },
  },
  businessLabelCompleted: {
    marginTop: '7px',
    display: 'block',
    font: 'normal normal normal 12px Arial',
    fontWeight: '700',
    letterSpacing: '0.1px',
    color: '#661C69',
    opacity: 1,
    width: 'min-content',
    '@media (max-width:600px)': {
      font: 'normal normal 700 12px/14px Arial',
      fontWeight: '700',
      letterSpacing: '0.1px',
      color: '#661C69',
      opacity: 1,
      width: 'min-content',
    },
  },
  businessLabelConsent: {
    marginTop: '7px',
    display: 'block',
    font: 'normal normal normal 14px/17px Arial',
    letterSpacing: '0.1px',
    color: '#555858',
    opacity: 1,
    '@media (max-width:600px)': {
      fontSize: '9px',
      fontWeight: 'bolder',
    },
  },
  iconWrapper: {
    width: '100%',
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'auto',
    textAlign: 'center',
  },
  inviStyle: {
    display: 'none',
  },
  steps: {
    height: '36px',
    width: '36px',
    font: 'normal normal bold 16px Arial',
    letterSpacing: '0.08px',
    color: ORIENTAL_D_GRAY,
    backgroundColor: '#F3F3F3',
    display: 'block',
    lineHeight: '36px',
    textAlign: 'center',
    border: '2px solid #D0D0D0',
    borderRadius: '50%',
  },
  completed: {
    border: '3px solid #661C69',
    backgroundColor: WHITE,
    color: '#661C69',
  },
  current: {
    border: '3px solid #661C69',
    backgroundColor: WHITE,
  },
  upcoming: {
    border: '3px solid #D0D0D0',
    backgroundColor: WHITE,
  },
  fullycompleted: {
    border: '3px solid #661C69',
    color: WHITE,
    backgroundColor: '#661C69',
  },
  firstIcon: {
    '@media (max-width:600px)': {
      left: '-2%',
    },
    '@media (max-width:540px)': {
      left: '-3%',
    },
    '@media (max-width:440px)': {
      left: '-4%',
    },
  },
};
